import { Controller } from '@hotwired/stimulus'

// Reads the data-birthdays JSON from the host element and emits a browser Notification
// for each birthday today (idempotent : localStorage keeps track of already-notified ids).
//
// Usage:
//   data-controller="browser-notifications"
//   data-browser-notifications-enabled-value="true"
//   data-browser-notifications-today-value="2026-06-15"
//   data-browser-notifications-birthdays-value='[{"id":1,"name":"Aude","cake":"Tarte","celebrated":false}]'
//   data-browser-notifications-icon-value="/logo.svg"
export default class extends Controller {
  static values = {
    enabled: { type: Boolean, default: false },
    today: String,
    birthdays: Array,
    icon: { type: String, default: '/logo.svg' }
  }

  connect() {
    if (!this.enabledValue) return
    if (!('Notification' in window)) return
    if (Notification.permission !== 'granted') return
    if (this.birthdaysValue.length === 0) return

    const storageKey = `capsens_birthdays_notified_${this.todayValue}`
    const alreadyNotified = JSON.parse(localStorage.getItem(storageKey) || '[]')

    this.birthdaysValue.forEach((birthday) => {
      if (alreadyNotified.includes(birthday.id)) return

      this.#notify(birthday)
      alreadyNotified.push(birthday.id)
    })

    localStorage.setItem(storageKey, JSON.stringify(alreadyNotified))
    this.#cleanupOldKeys(storageKey)
  }

  #notify(birthday) {
    const cakeLine = birthday.cake ? `\u{1F370} ${birthday.cake}` : '\u{1F370} G\u00E2teau pr\u00E9f\u00E9r\u00E9 non renseign\u00E9'
    const body = birthday.celebrated ? `${cakeLine} (d\u00E9j\u00E0 f\u00EAt\u00E9 \u2713)` : cakeLine

    const notification = new Notification(`\u{1F382} ${birthday.name} f\u00EAte son anniversaire !`, {
      body,
      icon: this.iconValue,
      tag: `birthday-${this.todayValue}-${birthday.id}`,
      requireInteraction: false
    })

    notification.onclick = () => {
      window.focus()
      window.location.href = `/employees/${birthday.id}`
    }
  }

  #cleanupOldKeys(currentKey) {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('capsens_birthdays_notified_') && key !== currentKey) {
        localStorage.removeItem(key)
      }
    })
  }
}
